module.exports = __webpack_public_path__ + "img/shopify.4d3dcec8.png";